module.exports = {
	config: {
		headlineKey: 'order.properties.history.title'
	},
	model: {
		historyEntries: [],
		stateMapping: {}
	},
	methods: {
		sanitizeResources(storage){
			if(!storage.isServer){
				var self = this;
				const langCode = storage.langCode || 'de-at'
				self.parent(function(parent){
					self.model.historyEntries = (((parent.resourceData.data || {}).children || {}).ttgshop_orders_history || {}).data || [];
					self.model.historyEntries.push(parent.resourceData.data || {});
					var stateOptions = (((parent.model.namedFields || {}).state || {})['category-picker-data'] || {}).options || [];

					if(stateOptions.length > 0){
						for(var option of stateOptions){
							var optionName = ((option.lang || {})[langCode] || {}).name || '';
							if(option.value !== undefined && optionName){
								self.model.stateMapping[option.value] = optionName
							}
						}
					}
				})
			}
		}
	}
}